import React, { useState, useEffect, useContext } from "react";
import { useNavigate } from "react-router-dom";
import { Eye, EyeOff } from "lucide-react";
import axios from "axios";
import Swal from "sweetalert2";
import AppContext from "../../../../context/AppContext";
import "../../../../assets/styles/customer/CustomerLogin.css";
import { Spinner } from "react-bootstrap";

const CustomerLogin = () => {
  const navigate = useNavigate();
  const { baseUrl } = useContext(AppContext);
  const [showPw, setShowPw] = useState(false);
  const [phone, setPhone] = useState("");
  const [password, setPassword] = useState("");
  const [isLoading, setIsLoading] = useState(true);
  const [isButtonLoading, setIsButtonLoading] = useState(false);

  // auto login
  useEffect(() => {
    const savedPhone = localStorage.getItem("customerPhone");
    const savedPassword = localStorage.getItem("customerPassword");

    if (savedPhone && savedPassword) {
      autoLogin(savedPhone, savedPassword);
    } else {
      setIsLoading(false); // ✅ FIX: koi saved data nahi to spinner band karo
    }
  }, []);

  const autoLogin = (savedPhone, savedPassword) => {
    const formData = new FormData();
    formData.append("phonenumber", savedPhone);
    formData.append("password", savedPassword);

    axios
      .post(`${baseUrl}/customer/auth/loginCustomer`, formData)
      .then((response) => {
        if (response.data.success === true) {
          navigate("/customer/dashboard");
        }
      })
      .catch((error) => {
        console.log(error);
      })
      .finally(() => {
        setIsLoading(false);
      });
  };

  const customerLogin = () => {
    setIsButtonLoading(true);

    const formData = new FormData();
    formData.append("phonenumber", phone);
    formData.append("password", password);

    axios
      .post(`${baseUrl}/customer/auth/loginCustomer`, formData)
      .then((response) => {
        if (response.data.success === true) {
          const customer = response.data.customer;

          // ✅ FIX: pehle sab localStorage mein save karo, PHIR navigate karo
          localStorage.setItem("customerPhone",    phone);
          localStorage.setItem("customerPassword", password);
          localStorage.setItem("customerId",       customer.id);
          localStorage.setItem("customerData",     JSON.stringify(customer));

          console.log("✅ Saved customerId:", customer.id);

          // ✅ FIX: navigate BAAD mein
          navigate("/customer/dashboard");

          Swal.fire({
            title: "Welcome Back!",
            text: "Hello! How are you today!",
            icon: "success",
            confirmButtonText: "Close",
          });

        } else {
          Swal.fire({
            title: "Oops",
            text: response.data.message || "Unable to login!",
            icon: "error",
            confirmButtonText: "Close",
          });
        }
      })
      .catch((error) => {
        console.log(error);
      })
      .finally(() => {
        setIsButtonLoading(false);
      });
  };

  return (
    <>
      <div className="clog-bg">
        {/* ✅ FIX: isLoading true ho to spinner, false ho to form */}
        {isLoading ? (
          <div className="d-flex justify-content-center align-items-center" style={{ minHeight: '100vh' }}>
            <Spinner animation="border" role="status">
              <span className="visually-hidden">Loading...</span>
            </Spinner>
          </div>
        ) : (
          <div className="clog-card">
            <div className="clog-logo-wrap">
              <div className="clog-logo">
                <i className="bi bi-droplet-fill" />
              </div>
            </div>

            <h1 className="clog-title">Welcome Back</h1>
            <p className="clog-subtitle">Sign in to your MilkyWay account</p>

            <div className="clog-form-group">
              <label className="clog-label">Phone Number</label>
              <div className="clog-input-wrap">
                <i className="bi bi-telephone clog-input-icon" />
                <input
                  className="clog-input"
                  placeholder="03001234567"
                  value={phone}
                  onChange={(e) => setPhone(e.target.value)}
                />
              </div>
            </div>

            <div className="clog-form-group">
              <label className="clog-label">Password</label>
              <div className="clog-input-wrap">
                <i className="bi bi-lock clog-input-icon" />
                <input
                  className="clog-input clog-input--pw"
                  type={showPw ? "text" : "password"}
                  placeholder="Enter your password"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                />
                <button
                  className="clog-pw-eye"
                  type="button"
                  onClick={() => setShowPw((s) => !s)}
                >
                  {showPw ? <EyeOff size={15} /> : <Eye size={15} />}
                </button>
              </div>
            </div>

            <button
              className="clog-submit-btn"
              onClick={customerLogin}
              disabled={isButtonLoading}
            >
              {isButtonLoading ? "Logging in..." : "Login"}
            </button>

            <p className="clog-register-link">
              Don't have an account?{" "}
              <button
                className="clog-link-btn"
                onClick={() => navigate("/customer/register")}
              >
                Create Account
              </button>
            </p>
          </div>
        )}
      </div>
    </>
  );
};

export default CustomerLogin;